




import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class WritingTask1 extends Vue {}
